import {
  AddBookingTenantSettingsDto,
  PatchBookingTenantSettingsDto
} from "@libs/gateways/booking/BookingGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";

import { BookingTenantSettingValues } from "./BookingTenantSettingsForm.types.ts";
import { tenantSettingFormDropdown } from "./TenantSettingsFormDropDown.tsx";

export const useBookingTenantSettingsFormSubmit = () => {
  const { booking, clinical, formDesign } = useStores();

  const onSubmit = async (values: BookingTenantSettingValues) => {
    const promises: Promise<any>[] = [];

    const tenantSettings = booking.tenantSettings;

    if (tenantSettings) {
      const dataPatch: PatchBookingTenantSettingsDto = {
        appointmentConfirmationSettings: {
          isActive: values.apptConfirmationEnabled
        },
        eTag: tenantSettings.eTag
      };
      promises.push(booking.updateTenantSettings(dataPatch));
    } else {
      const dataAdd: AddBookingTenantSettingsDto = {
        appointmentConfirmationSettings: {
          isActive: values.apptConfirmationEnabled
        }
      };
      promises.push(booking.addTenantSettings(dataAdd));
    }

    const getFormIdFromTypeCode = (code: string) => {
      const design = formDesign.formDesigns?.find(x => x.formTypeCode === code);
      return design?.id;
    };

    if (
      values.demographics &&
      values.demographics !==
        getFormIdFromTypeCode(tenantSettingFormDropdown.demographics.typeCode)
    ) {
      promises.push(
        formDesign.setFormTypeCode(
          values.demographics,
          tenantSettingFormDropdown.demographics.typeCode
        )
      );
    }

    if (
      values.acc &&
      values.acc !==
        getFormIdFromTypeCode(tenantSettingFormDropdown.acc.typeCode)
    ) {
      promises.push(
        formDesign.setFormTypeCode(
          values.acc,
          tenantSettingFormDropdown.acc.typeCode
        )
      );
    }

    if (
      values.accDemographics &&
      values.accDemographics !==
        getFormIdFromTypeCode(
          tenantSettingFormDropdown.accDemographics.typeCode
        )
    ) {
      promises.push(
        formDesign.setFormTypeCode(
          values.accDemographics,
          tenantSettingFormDropdown.accDemographics.typeCode
        )
      );
    }

    const clinicalActivityPreference = clinical.clinicalActivitiesPreference;

    if (clinicalActivityPreference) {
      promises.push(
        clinical.patchClinicalActivitiesPreference({
          id: clinicalActivityPreference.id,
          notifyUpcommingReminders: !!values.notifyUpcomingReminders,
          eTag: clinicalActivityPreference.eTag
        })
      );
    }

    await Promise.all(promises);
  };

  return onSubmit;
};
